import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import { Forward } from "components/common/Icons";
import { usePopularDiscuss } from "utils/clientAPIs/discuss";
import SkeletonBlock from "components/skeleton";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";

function PopularResearchList() {
  const router = useRouter();
  const { t } = useTranslation("main");
  const [data, isLoading] = usePopularDiscuss();
  const isLoading2 = !data || data.length === 0 || isLoading;
  if (isLoading2)
    return (
      <div className="px-5 pb-[90px] flex flex-col gap-9">
        <SkeletonBlock width={"100%"} height={30} />
        <div className="flex flex-col gap-3">
          <SkeletonBlock width={"100%"} height={68} />
          <SkeletonBlock width={"100%"} height={68} />
          <SkeletonBlock width={"100%"} height={68} />
          <SkeletonBlock width={"100%"} height={68} />
          <SkeletonBlock width={"100%"} height={68} />
        </div>
      </div>
    );

  return (
    <div className="px-5  pb-[90px] flex flex-col gap-9">
      <p className={`${TYPO.TYPO3_SB} text-gray90 text-center`}>
        {t("popularNow")}
      </p>
      <TrackedList listId="feed_popular_reports_list" totalCount={data?.length}>
        <div className="flex flex-col">
          {data?.map((item: any, index: number) => {
            return (
              <TrackedListItem
                itemData={{
                  kind: "report",
                  report_id: item.id,
                  rank: index + 1,
                }}
                href={`/discuss/${
                  item.url_slug ? `${item.url_slug}-${item.id}` : item.id
                }`}
                key={index}
                data-gtm-id={`feed-popular-research-list`}
                className="w-full cursor-pointer"
                // onClick={() => {
                //   router.push(
                //     `/discuss/${
                //       item.url_slug ? `${item.url_slug}-${item.id}` : item.id
                //     }`
                //   );
                // }}
              >
                <div className="flex items-center hover:bg-gray2 rounded-[8px] px-3 py-[10px] w-full gap-3">
                  <p
                    className={`text-[15px] leading-[16px] font-semibold text-center text-blue40`}
                  >
                    {index + 1}
                  </p>
                  <p
                    className={`${TYPO.TYPO5_1_SB} text-gray80 leading-[26px] grow break-keep`}
                  >
                    {item.title}
                  </p>
                  <Forward fill={"gray30"} height={16} width={16} />
                </div>
                <div
                  className={`bg-gray15 h-[1px] w-full ${
                    data?.length === 1 || index === data?.length - 1
                      ? "hidden"
                      : "my-2 "
                  }`}
                />
              </TrackedListItem>
            );
          })}
        </div>
      </TrackedList>
    </div>
  );
}

export default PopularResearchList;
